import axios from "axios";
import { APP_URL } from "../../../config/api";
import { errorMessage } from "../../errorHandle";

export const getUserWiseTraining = () => {
  return (dispatch) => {
    dispatch({
      type: LP_USER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/lpu/get-trainings`,
      })
      .then((res) => {
        dispatch({
          type: LP_USER.USER_WISE_TRAINING,
          payload: res.data.list,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, LP_USER.ERROR));
      });
  };
};

export const getTrainingCertificateDownload = (par) => {
  return (dispatch) => {
    dispatch({
      type: LP_USER.REQUEST,
    });
    axios
      .request({
        method: "post",
        data: par,
        url: `${APP_URL}/lpu/download-certificate`,
      })
      .then((res) => {
        dispatch({
          type: LP_USER.DOWNLOAD_CERTIFICATE,
          payload: res.data.list,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, LP_USER.ERROR));
      });
  };
};

export const updateUserTrainingJoinStatus = (details) => {
  return (dispatch) => {
    axios
      .request({
        method: "post",
        url: `${APP_URL}/lp/update-training-join-status`,
        data: details,
      })
      .then((res) => {
        dispatch({
          type: LP_USER.UPDATE_TRAINING_JOIN_STATUS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, LP_USER.ERROR));
      });
  };
};

export const getLPUDashboarData = () => {
  return (dispatch) => {
    dispatch({
      type: LP_USER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/lpu/dashboard-data`,
      })
      .then((res) => {
        dispatch({
          type: LP_USER.DASHBOARD_DATA,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, LP_USER.ERROR));
      });
  };
};

export const getTrainingStartStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: LP_USER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/lpu/training-start-status`,
        data: data,
      })
      .then((res) => {
        dispatch({
          type: LP_USER.TRAINING_START_STATUS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, LP_USER.ERROR));
      });
  };
};

export const verifyTrainingCertificate = (data) => {
  return (dispatch) => {
    dispatch({
      type: LP_USER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/verify-certificates`,
        data: data,
      })
      .then((res) => {
        dispatch({
          type: LP_USER.VERIFIY_CERTIFICATE,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, LP_USER.ERROR));
      });
  };
};

export const getUserWiseTrainingDetails = (data) => {
  return (dispatch) => {
    dispatch({
      type: LP_USER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-user-training-details`,
        data: data,
      })
      .then((res) => {
        dispatch({
          type: LP_USER.USER_WISE_TRAINING_DETAILS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, LP_USER.ERROR));
      });
  };
};

export const addUserTrainingAttendance = (data) => {
  return (dispatch) => {
    dispatch({
      type: LP_USER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/add-training-attendance`,
        data: data,
      })
      .then((res) => {
        dispatch({
          type: LP_USER.ADD_USER_WISE_TRAINING_ATTENDANCE,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, LP_USER.ERROR));
      });
  };
};

export const addUserTrainingRating = (data) => {
  return (dispatch) => {
    dispatch({
      type: LP_USER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/add-training-rating`,
        data: data,
      })
      .then((res) => {
        dispatch({
          type: LP_USER.USER_WISE_TRAINING_RATING,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, LP_USER.ERROR));
      });
  };
};

export const checkTrainingStartStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: LP_USER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/check-training-status`,
        data: data,
      })
      .then((res) => {
        dispatch({
          type: LP_USER.CHECK_TRAINING_START_STATUS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, LP_USER.ERROR));
      });
  };
};

export const resetTrainingStartStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: LP_USER.RESET_TRAINING_START_STATUS,
      payload: "",
    });
  };
};

const TAG = "LP_";

export const LP_USER = {
  ERROR: TAG + "ERROR",
  REQUEST: TAG + "REQUEST",
  UPDATE_TRAINING_JOIN_STATUS: TAG + "UPDATE_TRAINING_JOIN_STATUS",
  USER_WISE_TRAINING: TAG + "USER_WISE_TRAINING",
  DASHBOARD_DATA: TAG + "DASHBOARD_DATA",
  TRAINING_START_STATUS: TAG + "TRAINING_START_STATUS",
  DOWNLOAD_CERTIFICATE: TAG + "DOWNLOAD_CERTIFICATE",
  VERIFIY_CERTIFICATE: TAG + "VERIFIY_CERTIFICATE",
  USER_WISE_TRAINING_DETAILS: TAG + "USER_WISE_TRAINING_DETAILS",
  ADD_USER_WISE_TRAINING_ATTENDANCE: TAG + "ADD_USER_WISE_TRAINING_ATTENDANCE",
  USER_WISE_TRAINING_RATING: TAG + "USER_WISE_TRAINING_RATING",
  CHECK_TRAINING_START_STATUS: TAG + "CHECK_TRAINING_START_STATUS",
  RESET_TRAINING_START_STATUS: TAG + "RESET_TRAINING_START_STATUS",
};
